export default "__VITE_ASSET__DSaQ91pD__"